import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    if (!localStorage.getItem("uid")) {
      this.router.navigate([`login`]);
    }
  }

  logout() {
    firebase.auth().signOut();
    localStorage.clear();
    this.router.navigate([`login`]);
  }

}
